// The UFORouteName object is a global singleton
const UFORouteName = {
  current: null
};
export default UFORouteName;